export const gridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
};

export const gridColumns = [
  {
    headerName: 'Award',
    field: 'position',
    minWidth: 300,
    sort: 'asc',
    valueGetter: (params) => params.data.nomination.award.name,
  },
  {
    headerName: 'Nominee',
    field: 'nominee',
    flex: 1,
    minWidth: 200,
    valueGetter: (params) => {
      const { nomination } = params.data;

      return nomination.identification;
    },
  },
  {
    headerName: 'Nominator',
    field: 'nominee',
    flex: 1,
    minWidth: 200,
    valueGetter: (params) => {
      const { nomination } = params.data;

      if (!nomination.affiliate) {
        return 'No match';
      }

      return nomination.affiliate.name;
    },
  },
  {
    headerName: 'Status',
    field: 'status',
    minWidth: 200,
    valueGetter: (params) => params.data.status.label,
  },
  {
    headerName: 'Date',
    field: 'date',
    minWidth: 200,
  },
];
